<div class="container">
  <h1>اختر اللعبة</h1>

  <div class="game-bar">
    <!--  <div class="game" [ngClass]="{'active':activeGame ==='all'}" (click)="setActiveGame('all')">All Games</div>-->
    <div class="game" *ngFor="let game of this.eventService.Games" [ngClass]="{'active':activeGame ===game.code}"
         (click)="setActiveGame(game.code)" >
      <img src="assets/img/ramadan2022/{{ game.code }}-ramadan2022.png" class="img-responsive"/>
      <div *ngIf="activeGame ===game.code" class="active-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="34.875" height="34.875" viewBox="0 0 34.875 34.875">
          <path data-name="Icon awesome-check-circle" d="M35.438 18A17.438 17.438 0 1 1 18 .563 17.437 17.437 0 0 1 35.438 18zm-19.455 9.233L28.921 14.3a1.125 1.125 0 0 0 0-1.591l-1.591-1.595a1.125 1.125 0 0 0-1.591 0L15.188 21.665l-4.926-4.926a1.125 1.125 0 0 0-1.591 0l-1.592 1.59a1.125 1.125 0 0 0 0 1.591l7.313 7.313a1.125 1.125 0 0 0 1.591 0z" transform="translate(-.563 -.563)" style="fill:#fbc955"/>
        </svg>

      </div>
    </div>
  </div>

  <ng-container *ngIf="participants != 0; else nodata">
    <div class="tab-content team">
      <div class="team-container"
           *ngFor="let participant of participants;index as index"
           id="{{participant.original.participant_id}}"
           [ngClass]="{'incomplete': participant.incomplete}">
        <div class="flex_block">
          <div style="display: flex">
            <img [src]="participant.original.avatar" alt="team_image"/>
            <div class="info">
              <h1>{{participant.original?.participant_name|truncate :participant.truncate}}</h1>
              <div class="flex_block">
                <div class="item">
                  <div class="flag_container_rounded">
                    <img
                      src="assets/img/flags/{{globalService.getCountryAbbr(participant?.original.country)}}.svg"
                      alt="{{participant?.original.country}}">
                  </div>

                  <p style="margin: 3px">{{participant?.original.country}}</p>
                </div>
                <!--            <div class="item">-->
                <!--              <svg-icon name="capitain"></svg-icon>-->
                <!--              <p>{{participant?.original?.leader?.username|truncate:20}}</p>-->
                <!--            </div>-->
              </div>
            </div>
          </div>

          <h5>100 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path data-name="Icon awesome-coins"
                  d="M0 19v2c0 1.655 4.031 3 9 3s9-1.345 9-3v-2c-1.936 1.364-5.475 2-9 2s-7.064-.637-9-2zM15 6c4.969 0 9-1.345 9-3s-4.031-3-9-3-9 1.345-9 3 4.031 3 9 3zM0 14.081V16.5c0 1.655 4.031 3 9 3s9-1.345 9-3v-2.419c-1.936 1.594-5.48 2.419-9 2.419s-7.064-.825-9-2.419zm19.5.516c2.686-.52 4.5-1.486 4.5-2.6V10a11.511 11.511 0 0 1-4.5 1.617zM9 7.5c-4.969 0-9 1.678-9 3.75S4.031 15 9 15s9-1.678 9-3.75S13.969 7.5 9 7.5zm10.28 2.639C22.092 9.633 24 8.639 24 7.5v-2c-1.664 1.177-4.523 1.809-7.533 1.959a5.249 5.249 0 0 1 2.813 2.68z"
                  style="fill:#fda60e"/>
          </svg></h5>
        </div>
        <!--<i class="icon-attention" *ngIf="participant.incomplete"></i>-->
      </div>
    </div>
  </ng-container>
  <ng-template #nodata>
    <div class="no-data " *ngIf="participants?.length==0">
      <h2>لا يوجد متأهلين حتي الآن</h2>
    </div>
  </ng-template>
</div>
